import {
  authorizeDeleteRequest,
  authorizeGetRequest,
  authorizePostRequest,
} from "api";
import { IPaginatedResponse } from "models";
import { IAppVersion, ICreateAppVersion } from "models/appVersion";

export const appVersionsApi = () => {
  return authorizeGetRequest<IPaginatedResponse<IAppVersion>>(`app-versions`);
};

export const createAppVersionsApi = (data: ICreateAppVersion) => {
  return authorizePostRequest<IPaginatedResponse<IAppVersion>>(
    `app-versions`,
    data
  );
};

export const deleteAppVersionApi = (id: string) => {
  return authorizeDeleteRequest<IPaginatedResponse<IAppVersion>>(
    `app-versions/${id}`
  );
};
